import { HANDICAP_ALLOWANCE } from '@/lib/games/handicap';

const OPTIONS = [0.25, 0.5, 0.85, 0.9, 0.95, 1.0];

const FORMAT_HINTS: Record<string, string> = {
  fourball: 'USGA recommends 85% for four-ball / better-ball.',
  bestball: 'USGA recommends 85% for four-ball / better-ball.',
  scramble: 'Scrambles often use mixed percentages (25/20/15/10).',
  stroke: 'Stroke play often uses 95%.',
  nassau: '100% is standard for match play.',
  match: '100% is standard for match play.',
  skins: '100% is most common for skins. Some clubs use 90%.',
};

interface Props {
  formatId: string;
  formatName?: string;
  value: number;
  onChange: (allowance: number) => void;
}

export function HandicapAllowancePicker({ formatId, formatName, value, onChange }: Props) {
  const defaultAllowance = HANDICAP_ALLOWANCE[formatId] ?? 1.0;
  const hint = FORMAT_HINTS[formatId] ?? 'Adjust if your club uses different rules for this format.';

  return (
    <div className="rounded-xl border border-line bg-paper p-3">
      <div className="text-xs font-bold uppercase tracking-wider text-navy">Handicap allowance</div>
      <p className="mt-1 text-[10px] leading-relaxed text-slate-500">{hint}</p>
      <div className="mt-3 flex flex-wrap gap-1.5">
        {OPTIONS.map((a) => (
          <button
            key={a}
            type="button"
            onClick={() => onChange(a)}
            className={`min-w-[3.5rem] flex-1 rounded-lg px-2.5 py-2 text-xs font-bold ${
              Math.abs(value - a) < 0.001
                ? 'bg-navy text-cream'
                : 'border border-line bg-cream text-slate-600'
            }`}
          >
            {(a * 100).toFixed(0)}%
          </button>
        ))}
      </div>
      {Math.abs(value - defaultAllowance) > 0.001 && (
        <p className="mt-2 text-[10px] font-semibold text-gold-deep">
          Non-standard for {formatName || formatId}. USGA default: {(defaultAllowance * 100).toFixed(0)}%
        </p>
      )}
    </div>
  );
}
